import React from "react";
import { IconButton } from "../icon-button";

import "./command-history.css";
import { useKeyDown } from "../../hooks/useKeyboard";
import classNames from "classnames";

export const CommandHistory = ({
	isUndoDisabled,
	onUndoClick,
	isRedoDisabled,
	onRedoClick,
	elevated = true,
}: {
	isUndoDisabled: boolean;
	onUndoClick(): void;
	isRedoDisabled: boolean;
	onRedoClick(): void;
	elevated?: boolean;
}) => {
	// Global key bindings for undo/redo but conditionally when component is mounted
	useKeyDown((event) => {
		if (event.key === "z" && (event.metaKey || event.ctrlKey)) {
			if (!isUndoDisabled) {
				onUndoClick();
				event.preventDefault();
			}
		} else if (
			(event.key === "y" && (event.metaKey || event.ctrlKey)) ||
			(event.key === "Z" && (event.metaKey || event.ctrlKey)) // uppercase Z for ctrl+shift+z
		) {
			if (!isRedoDisabled) {
				onRedoClick();
				event.preventDefault();
			}
		}
	});

	const styles = classNames("command-history", {
		"command-history--elevated": elevated,
	});

	return (
		<span className={styles}>
			<IconButton
				className="command-history__undo"
				iconName="undo"
				onClick={onUndoClick}
				disabled={isUndoDisabled}
			/>
			<IconButton
				className="command-history__redo"
				iconName="redo"
				onClick={onRedoClick}
				disabled={isRedoDisabled}
			/>
		</span>
	);
};
CommandHistory.displayName = "CommandHistory";
